"use client";

import { Card, CardHeader, CardTitle, CardContent } from "../ui/card";

export function DiscordWidget() {
  const serverId = "1434954702247956654";
  
  return (
    <Card>
      <CardHeader>
        <CardTitle className="truncate">Discord Junta de Hermandades</CardTitle>
      </CardHeader>
      <CardContent>
         <iframe 
            src={`https://discord.com/widget?id=${serverId}&theme=dark`}
            width="100%" 
            height="400" 
            allowTransparency={true} 
            frameBorder="0" 
            sandbox="allow-popups allow-popups-to-escape-sandbox allow-same-origin allow-scripts"
            className="w-full"
         ></iframe>
      </CardContent>
    </Card>
  );
}
